import { Input as BaseInput, InputProps } from "baseui/input";
import { Theme, useTheme } from "@src/common/components/ThemeProvider/ThemeProvider";

const Input: React.FC<InputProps> = (props) => {
  const { effectiveTheme } = useTheme();
  return (
    <BaseInput
      {...props}
      overrides={{
        ...props.overrides,
        Input: {
          ...props.overrides?.Input,
          style: {
            backgroundColor: effectiveTheme === Theme.DARK ? "rgb(11 21 35)" : "rgb(249 250 251)",
            colorScheme: effectiveTheme === Theme.DARK ? "dark" : "light",
            ...props.overrides?.Input?.style,
          },
        },
      }}
    />
  );
};

export default Input;
